const lostPasswordValidation = () => {
    document.addEventListener("DOMContentLoaded", () => {
        const form = document.querySelector(".woocommerce-ResetPassword");
        if (!form) return;

        const emailInput = form.querySelector("#user_login");
        const submitBtn = form.querySelector('button[type="submit"]');
        const nonceInput = form.querySelector("#woocommerce-lost-password-nonce");
        const loader = form.querySelector(".wc-loader");
        if (!nonceInput) return;

        const showInputError = (input, message) => {
            let errorEl = input.nextElementSibling;
            if (errorEl && errorEl.classList.contains("input-error")) {
                errorEl.remove();
            }

            if (message) {
                input.classList.add("wpcf7-not-valid");
                const div = document.createElement("div");
                div.className = "input-error";
                div.style.color = "red";
                div.style.fontSize = "0.9em";
                div.style.marginTop = "5px";
                div.textContent = message;
                input.parentNode.insertBefore(div, input.nextSibling);
            } else {
                input.classList.remove("wpcf7-not-valid");
            }
        };

        const validateEmail = () => {
            const email = emailInput.value.trim();
            if (!email) return rcTranslate.enterEmail;
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return rcTranslate.incorrectEmail;
            return "";
        };

        emailInput.addEventListener("input", () => {
            submitBtn.disabled = false;
            submitBtn.textContent = rcTranslate.resetPassword;
            if (loader) loader.style.display = "none";
            showInputError(emailInput, "");
        });

        const handleSubmit = (e) => {
            e.preventDefault();

            const error = validateEmail();
            if (error) {
                showInputError(emailInput, error);
                if (loader) loader.style.display = "none";
                return;
            }

            showInputError(emailInput, "");
            submitBtn.disabled = true;
            submitBtn.textContent = rcTranslate.processing || "Зачекайте...";
            if (loader) loader.style.display = "inline-block";

            const data = new URLSearchParams();
            data.append("action", "ajaxPasswordResetHandler");
            data.append("email", emailInput.value.trim());
            data.append("_ajax_nonce", rcData.nonce);

            fetch(rcData.ajaxUrl, {
                method: "POST",
                body: data,
            })
                .then((res) => res.json())
                .then((response) => {
                    if (response.success) {
                        if (loader) loader.style.display = "none";
                        form.removeEventListener("submit", handleSubmit);
                        form.submit();
                    } else {
                        showInputError(emailInput, response.data);
                        submitBtn.disabled = false;
                        submitBtn.textContent = rcTranslate.resetPassword;
                        if (loader) loader.style.display = "none";
                    }
                })
                .catch(() => {
                    showInputError(emailInput, rcTranslate.requestError);
                    submitBtn.disabled = false;
                    submitBtn.textContent = rcTranslate.resetPassword;
                    if (loader) loader.style.display = "none";
                });
        };

        form.addEventListener("submit", handleSubmit);
    });
};

export default lostPasswordValidation;
